
Checkout.Payment.Summary = function(checkout, payment) {
	var summary = this;

	this.$content = $('#payment-sidebar-summary');
	this.$itemContainer = $('#payment-sidebar-summary-container');
	this.$itemTpl = $('#payment-sidebar-summary-item-tpl');

	this.init = function() {
		summary.listen();
	};

	this.listen = function() {

		summary.$content.click(function() {
			$('html,body').animate(
				{ 'scrollTop': checkout.cart.$anchor.offset().top },
				500
			);
		});

	};

	this.buildContent = function() {
		var items = [],
      prodImgSize = pointsBreak.getWidth() > 480 ? 100 : 300;

		$('.shoppingCartNList')
			.not('#cart-item-tpl')
			.each(function(i, itemRow) {
				var cartItemKey = itemRow.id.replace('cart-item-', ''),
					item = checkout.cart.items[cartItemKey],
					$item =
						summary.$itemTpl
							.clone(true)
							.removeAttr('id')
							.attr('title', item.data.clean_description);

				if (item.data.mainImage){
					$item.find('img')
						.attr('src', CDNproduct + '/' + item.data.mainImage + '_x'+prodImgSize+'.jpg')
						.attr('alt', item.data.clean_description);
        }else{
          $item.find('img')
						.attr('src', CDNpath + '/img/bg_no-image_100x75.jpg')
						.attr('alt', item.data.clean_description);
        }

				$item.find('.sum_qty').html(
					item.data.qty + ' &times; $' + commaSeparate(item.unitprice.toMoney())
				);

				$item.find('.sum_amt').html(
					'$' + commaSeparate((item.data.qty * item.unitprice).toMoney())
				)

				items.push($item);
			});

		summary.$itemContainer.html(items);
	};

	this.init();
};

